import { getOrgDepartments } from "../services/globalData"

export const findDepartment = (department) =>{
     return getOrgDepartments().find((dept)=>dept._id===department);
}